import { useCallback, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { usePageStartBootstrap } from '../hooks/use_page_start_bootstrap';
import { processError } from '../utils/base_error';
import { useDependencyInjection } from '../../config/di/dependency_injection_context';
import { usePageLoader } from '../contexts/page_content_context';
import { DropDown } from '../domain/models/dropdown';
import { useDropDownLoader } from '../hooks/use_dropdown_loader';

type Props = {
  name: string;
  label?: string;
  newButtonLabel?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  disabled?: boolean;
  value: string | number | null | undefined;
  error?: boolean;
  helperText?: string | null;
  tipo?: string;
  incluirCodigoDescricao?: boolean;
  onChange: (newValue: string | number | undefined) => void;
};

export const DefaultProduto = ({
  name,
  label,
  required,
  readOnly,
  placeholder,
  disabled,
  value,
  error,
  helperText,
  tipo,
  incluirCodigoDescricao,
  onChange,
}: Props) => {

  const [produtoDropDown, setProdutoDropDown] = useState<DropDown[]>([]);

  const {
    loadProdutoServicosDropDown,
  } = useDropDownLoader();

  usePageStartBootstrap(async () => {
    loadProdutoServicosDropDown(dt =>
      setProdutoDropDown(dt.map(x => ({ id: x.idProdutoServico, title: x.descricao }))), { incluirCodigoDescricao });
  });


  return (
    <>
      <Autocomplete
        fullWidth={true}
        size="small"
        disablePortal
        options={produtoDropDown}
        getOptionLabel={(opt) => String(opt.title)}
        isOptionEqualToValue={(opt, val) => String(opt.title) === String(val.title)}
        sx={{ minHeight: 45 }}
        readOnly={readOnly}
        disabled={disabled}
        value={produtoDropDown.find(x => String(x.id) === String(value)) ?? null}
        onChange={(_, newValue) => {
          onChange(newValue ? newValue.id : undefined);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={label}
            error={error}
            helperText={helperText}
            placeholder={placeholder}
            required={required}
          />
        )}
      />
    </>
  );
};